// extracted by mini-css-extract-plugin
export default {"type":"TypeProject_type__x0Nzt","current_type":"TypeProject_current_type__2RvCO"};